export default __webpack_public_path__ + "vwq-icons.843c94d0.woff2";